import { ABNORMALITIES } from '../../constants';

export const canManifestBeEdited = manifest => {
    let editable = true;
    const hasRecoveryActions =
        manifest.allManifestRecoveryActions && manifest.allManifestRecoveryActions.length > 0;

    if (hasRecoveryActions) {
        const nonEditableRecoveryActions = manifest.allManifestRecoveryActions.filter(
            rec =>
                rec.status === 'ASSIGNED' || rec.status === 'CANCELLED' || rec.status === 'EXECUTED'
        );
        // Disable editing when there are only assigned/executed/cancelled recovery actions...
        editable = manifest.allManifestRecoveryActions.length > nonEditableRecoveryActions;
    }

    return editable;
};

export const hideSeverityColumn = (abnormalityType, viewingDetails) =>
    abnormalityType !== ABNORMALITIES.DELAY ||
    (abnormalityType === ABNORMALITIES.DELAY && !viewingDetails);
